var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.loading)?_c('v-progress-circular',{attrs:{"id":"loading_spinner","indeterminate":"","size":"64","color":"primary"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }